import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable(
{
      providedIn: 'root'
     })
export class AuthService {
  baseUrl = environment.apiUrl;
  urlExtenssion = localStorage.getItem("urlExtenssion");
  constructor(private http: HttpClient) { }

  public login(user : any) {
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=UTF-8');
    return this.http.post(this.baseUrl + '1/login', user, { headers: headers });
  }
  public set_token(data : any) {
    localStorage.setItem('token', data);
  }
  public get_token(): string | null {
    return localStorage.getItem('token');
  }
  checkPassword(password : string) {
    this.updateUrlExtention();
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=UTF-8');
    return this.http.post(this.baseUrl + `backoffice${this.urlExtenssion}/checkPassword`, { password: password }, { headers: headers });
  }
  forgetPassword(email : string) {
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=UTF-8');
    return this.http.post(this.baseUrl + 'forgetPassword', { email: email }, { headers: headers });
  }
  public logout() {
    this.updateUrlExtention();
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=UTF-8');
    return this.http.post(this.baseUrl + `backoffice${this.urlExtenssion}/logout`, {}, { headers: headers });
  }

  integrateWithOutlook() {
    this.updateUrlExtention();
    return this.http.get(this.baseUrl + `backoffice${this.urlExtenssion}/signInOutlook`);
  }

  activateOutlook(data : any) {
    this.updateUrlExtention();
    return this.http.get(this.baseUrl + `backoffice${this.urlExtenssion}/outlookAuth?${data}`);
  }
  updateUserPassword(body : any) {
    this.updateUrlExtention();
    return this.http.post(this.baseUrl + `backoffice${this.urlExtenssion}/updateUserPassword`, body);
  }

  updateUrlExtention() {
    this.urlExtenssion = localStorage.getItem("urlExtenssion");
    if (this.urlExtenssion == null) {
      this.urlExtenssion = ''
    }
  }
}
